<nb-card>
    <nb-card-header class="title-dialog">
        <h3 h3 style="color: white;">Modificar Contraseña</h3>
    </nb-card-header>
    <nb-card-body style="width: 100%;" class="bodyContainer">
        <form #changePassword='ngForm' class="left">
            <mat-form-field class="altaLabel col-6">
                <mat-label>Ingresar Contraseña</mat-label>
                <input matInput #contrasenia name='contrasenia' [type]="getInputTypePw()" [(ngModel)]="nuevaPassword"
                    autocomplete="new-password">
                <button mat-button matSuffix mat-icon-button aria-label="show" (click)="toggleShowPassword()">
                    <mat-icon>{{getIconPw()}}</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field class="altaLabel col-6">
                <mat-label>Repetir Contraseña</mat-label>
                <input matInput #REcontrasenia name='REcontrasenia' [type]="getInputTypeRePw()"
                    [(ngModel)]="nuevaRePassword" autocomplete="new-password">
                <button mat-button matSuffix mat-icon-button aria-label="show" (click)="toggleShowRPassword()">
                    <mat-icon>{{getIconRePw()}}</mat-icon>
                </button>
            </mat-form-field>
        </form>
        <div class="right">
            <div class="requiredContainer">
                <!-- <h4>La contraseña debe contener: </h4> -->
                <span [ngClass]="nuevaPassword.length < 8 ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="nuevaPassword.length < 8 ? 'reqIconError' : 'reqIconOk'">
                        {{nuevaPassword.length < 8 ? 'highlight_off' : 'check_circle_outline' }} </mat-icon> Como
                            minimo 8 caracteres
                </span>
                <span [ngClass]="nuevaPassword.length > 15  ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="nuevaPassword.length > 15 ? 'reqIconError' : 'reqIconOk'">
                        {{nuevaPassword.length > 15 ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Como maximo 15 caracteres
                </span>
                <span [ngClass]="passValidator.errorCapitalCase ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="passValidator.errorCapitalCase ? 'reqIconError' : 'reqIconOk'">
                        {{passValidator.errorCapitalCase ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Al menos una mayúscula
                </span>
                <span [ngClass]="passValidator.errorLowerCase ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="passValidator.errorLowerCase ? 'reqIconError' : 'reqIconOk'">
                        {{passValidator.errorLowerCase ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Al menos una minúscula
                </span>
                <span [ngClass]="passValidator.errorHasNumber ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="passValidator.errorHasNumber ? 'reqIconError' : 'reqIconOk'">
                        {{passValidator.errorHasNumber ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Al menos un numero
                </span>
                <span [ngClass]="passValidator.errorPassNotMatch ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="passValidator.errorPassNotMatch ? 'reqIconError' : 'reqIconOk'">
                        {{passValidator.errorPassNotMatch ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Las contraseñas <span *ngIf="passValidator.errorPassNotMatch">&nbsp;no&nbsp;</span>
                    coinciden
                </span>
            </div>
        </div>
    </nb-card-body>
    <nb-card-footer class="nuevousuarioCardFooter">
        <button nbButton size="tiny" class="buttontz" (click)="closeDialog()">
            Cancelar</button>
        <app-spinner *ngIf="showSpinner"></app-spinner>
        <button nbButton *ngIf="!showSpinner" size="tiny" class="buttontz" [disabled]='passValidator.passErrors'
            (click)="actualizarPassword()">
            Confirmar
        </button>
    </nb-card-footer>
</nb-card>